import Icon from "@chakra-ui/icon";
import React from "react";
export default function PasswordIcon({ ...props }) {
  return (
    <Icon
      {...props}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66668 0.666656H13.3333C14.0667 0.666656 14.6667 1.26666 14.6667 1.99999V9.99999C14.6667 10.7333 14.0667 11.3333 13.3333 11.3333H2.66668C1.93334 11.3333 1.33334 10.7333 1.33334 9.99999V1.99999C1.33334 1.26666 1.93334 0.666656 2.66668 0.666656Z"
        stroke="#ACACBE"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6667 2L8.00001 6.66667L1.33334 2"
        stroke="#ACACBE"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Icon>
  );
}
